import React,{useState, useEffect} from "react";
import { ToastContainer } from "react-toastify";
import "./App.css";
import Modal from '@mui/material/Modal';
// import Bubbles from "./components/Bubble/Bubbles";
import Routes from "./routes";

export const  tawkToLoadScripts=async ()=> {
  try {
    // Only load chat bot if URL is configured
    if (!import.meta.env.VITE_CHAT_BOT_URL) {
      console.log("Chat bot URL not configured");
      return;
    }

    await (function () {
        var s1 = document.createElement('script'),
        s0 = document.getElementsByTagName('script')[0];
        s1.async = true;
        s1.src = import.meta.env.VITE_CHAT_BOT_URL;
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        
        // Add error handling for script loading
        s1.onerror = function() {
          console.log("Error loading Tawk.to chat script");
        };
        
        s0.parentNode.insertBefore(s1, s0);
    })();
  } catch (error) {
    console.log("Error loading Tawk.to scripts:", error);
  }
}

window.Tawk_API = window.Tawk_API || {}
window.Tawk_LoadStart = new Date();

window.Tawk_API.onLoad = function () {
  console.log("chat loaded");
  try {
    // Only set attributes if we have valid data to set
    if (window.Tawk_API && typeof window.Tawk_API.setAttributes === 'function') {
      window.Tawk_API.setAttributes(
        {
          // Default attributes - can be empty object
        },
        function (error) {
          if (error) {
            console.log("Tawk.to error:", error);
          }
        }
      );
    }
  } catch (error) {
    console.log("Error initializing Tawk.to:", error);
  }
}

function App() {
  useEffect(() => {
    tawkToLoadScripts()
  }, [])
  
  const [open,setOpen]=useState(false);
  return (
    <>
      <div className="App">
        {/* <div style={{ zIndex: 0, height: "100%", width: "100%" }}>
          <Bubbles />
        </div> */}
        <Routes />
        <ToastContainer />
      </div>
      {/* <Modal open={open} onClose={()=>setOpen(false)}>
        <iframe src="../public/chatbot.js" name="iframe_a" height="400px" width="300px" style={{position:"relative", left:"70%", top:"60%"}} title="Iframe Example"></iframe>
      </Modal>
      <button className="chat-bot1" onClick={()=>setOpen(true)}><img src="/images/icons/chatbot.svg" alt="" /></button>
      <button className="chat-bot"><img src="/images/icons/whatsapp.svg" alt="" /></button> */}
    </>
  );
}

export default App;
